// API service for FiMod backend
const API_BASE_URL = 'https://fimod-landing-production.up.railway.app/api/v1';

export interface BetaSignupData {
  email: string;
  first_name?: string;
  company?: string;
  signup_source: 'hero' | 'beta-section';
}

export interface BetaSignupResponse {
  message: string;
  success: boolean;
  data?: {
    id?: string;
    email?: string;
    created_at?: string;
    already_registered?: boolean;
  };
}

class ApiService {
  private async request<T>(
    endpoint: string,
    options: RequestInit = {}
  ): Promise<T> {
    const url = `${API_BASE_URL}${endpoint}`;
    
    const config: RequestInit = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    };

    try {
      const response = await fetch(url, config);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  }

  async createBetaSignup(data: BetaSignupData): Promise<BetaSignupResponse> {
    return this.request<BetaSignupResponse>('/beta-signup', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async getSignupCount(): Promise<{ total_signups: number }> {
    return this.request<{ total_signups: number }>('/beta-signups/count');
  }
}

export const apiService = new ApiService();
